// import { ProcessMap } from "../../models/process-map.model";

import { ProcessMap } from "../../model/model";

export class ContractStateMap {


    static newState: ProcessMap = {
        state: 'NEW',
        id: 'NEW',
        label: 'Mới',
        text: 'Mới',
        confirmLabel: 'Chuyển sang Mới',
        status: 'danger',
        color: 'red',
        outline: false,
        confirmTitle: 'Chuyển trạng thái',
        confirmText: 'Bạn có muốn chuyển sang trạng thái Mới',
        responseTitle: 'Chuyển trạng thái',
        responseText: 'Đã chuyển sang trạng thái Mới',
    };
    static lawInfoUpdateState: ProcessMap = {
        state: 'LAWINFOUPDATE',
        id: 'LAWINFOUPDATE',
        label: 'Đã cập nhật đủ thông tin pháp lý',
        text: 'Đã cập nhật đủ thông tin pháp lý',
        confirmLabel: 'Cập nhật đủ thông tin pháp lý',
        status: 'warning',
        color: 'yellow',
        outline: false,
        confirmTitle: 'Chuyển trạng thái',
        confirmText: 'Bạn có chắc đã cập nhật đủ thông tin pháp lý?',
        responseTitle: 'Chuyển trạng thái',
        responseText: 'Đã chuyển sang trạng thái Cập nhật đủ thông tin pháp lý',
    };
    static contentLawApprovedState: ProcessMap = {
        state: 'CONTENTLAWAPPROVED',
        id: 'CONTENTLAWAPPROVED',
        label: 'Đã duyệt pháp lý nội dung',
        text: 'Đã duyệt pháp lý nội dung',
        confirmLabel: 'Duyệt pháp lý nội dung',
        status: 'info',
        color: 'lightblue',
        outline: false,
        confirmTitle: 'Chuyển trạng thái',
        confirmText: 'Bạn có muốn duyệt pháp lý nội dung',
        responseTitle: 'Chuyển trạng thái',
        responseText: 'Đã duyệt pháp lý nội dung',
    };
    static signingRequestState: ProcessMap = {
        state: 'SIGNINGREQUEST',
        id: 'SIGNINGREQUEST',
        label: 'Đã trình ký',
        text: 'Đã trình ký',
        confirmLabel: 'Trình ký',
        status: 'primary',
        color: 'blue',
        outline: false,
        confirmTitle: 'Chuyển trạng thái',
        confirmText: 'Bạn có muốn trình ký hợp đồng',
        responseTitle: 'Chuyển trạng thái',
        responseText: 'Đã trình ký hợp đồng',
    };
    static completedState: ProcessMap = {
        state: 'COMPLETED',
        id: 'COMPLETED',
        label: 'Đã hoàn tất',
        text: 'Đã hoàn tất',
        confirmLabel: 'Hoàn tất',
        status: 'basic',
        color: 'gray',
        outline: false,
        confirmTitle: 'Chuyển trạng thái',
        confirmText: 'Bạn có muốn hoàn tất hợp đồng',
        responseTitle: 'Chuyển trạng thái',
        responseText: 'Đã hoàn tất hợp đồng',
    };
    static destroyedState: ProcessMap = {
        state: 'DESTROYED',
        id: 'DESTROYED',
        label: 'Đã hủy',
        text: 'Đã hủy',
        confirmLabel: 'Hủy',
        status: 'basic',
        color: 'gray',
        outline: false,
        confirmTitle: 'Chuyển trạng thái',
        confirmText: 'Bạn có muốn hủy hợp đồng',
        responseTitle: 'Chuyển trạng thái',
        responseText: 'Đã hủy hợp đồng',
    };

    static contractStateMap: { [key: string]: ProcessMap } = {
        'NEW': {
            ...ContractStateMap.newState,
            nextState: 'LAWINFOUPDATE',
            nextStates: [
                ContractStateMap.lawInfoUpdateState,
                ContractStateMap.destroyedState,
            ],
        },
        'LAWINFOUPDATE': {
            ...ContractStateMap.lawInfoUpdateState,
            nextState: 'CONTENTLAWAPPROVED',
            nextStates: [
                ContractStateMap.contentLawApprovedState,
                ContractStateMap.destroyedState,
            ],
        },
        'CONTENTLAWAPPROVED': {
            ...ContractStateMap.contentLawApprovedState,
            nextState: 'SIGNINGREQUEST',
            nextStates: [
                ContractStateMap.signingRequestState,
                ContractStateMap.destroyedState,
            ],
        },
        'SIGNINGREQUEST': {
            ...ContractStateMap.signingRequestState,
            nextState: 'COMPLETED',
            nextStates: [
                ContractStateMap.completedState,
                ContractStateMap.destroyedState,
            ],
        },
        'COMPLETED': {
            ...ContractStateMap.completedState,
            nextState: 'DESTROYED',
            nextStates: [
                ContractStateMap.destroyedState,
            ],
        },
        'DESTROYED': {
            ...ContractStateMap.destroyedState,
            nextState: 'NEW',
            nextStates: [
                ContractStateMap.newState,
            ],
        },
    };
}
